import { ModelRow } from "@mcleod/core";
import { AutogenLayoutMobileCommSendMessage } from "./autogen/AutogenLayoutMobileCommSendMessage";
import {
    Button, DataSourceExecutionEvent, DataSourceMode, Layout, LookupModelSelectionEvent, ScreenStack,
    SlideoutDecorator, Toast
} from "@mcleod/components";
import { ModelMcUnit } from "../../mobilecomm/src/models/ModelMcUnit";

export class MobileCommSendMessage extends AutogenLayoutMobileCommSendMessage {
    private _unitNo: string;
    private _reply: boolean;
    private _slideOutModelRow: ModelRow;

    sendMessage(){
        this.mainDataSource.post().then(() => {
            Toast.showSuccessToast("Message Sent.");
        });
        const overlay = ScreenStack.getNewestOverlay();
        overlay?.component.slideOut();
    }

    textboxUnitOnLookupModelSelection(event: LookupModelSelectionEvent) {
        if (event.hasSelection() === true) {
            this.unitNo = event.selection.get("id");
            this.searchMessageByUnit(this.unitNo);
        }
    }

    searchMessageByUnit(unitNo: string){
        this.layoutMobileCommMessageTable.search({ "mc_unit_no": unitNo, "row_limit": 5 });
    }

    sourceMcMessageAfterModeChange(){
        if (this.reply && this.unitNo != null) {
            this.setUnitLookupData();
            this.setupExtraFields();
        }
    }

    sourceMcMessageAfterExecution(event: DataSourceExecutionEvent){
        this.textboxMessage.clear();
    }

    setupExtraFields(){
        this.mainDataSource.activeRow.set("order_id", this.slideOutModelRow.get("order_id"));
        this.mainDataSource.activeRow.set("movement_id", this.slideOutModelRow.get("movement_id"));
        this.mainDataSource.activeRow.set("driver_id", this.slideOutModelRow.get("driver_id"));
        this.mainDataSource.activeRow.set("mc_form_number", 0);
    }

    async setUnitLookupData() {
        await new ModelMcUnit().searchSingle({ "id": this.unitNo }).then(rowMcUnit => {
            if (rowMcUnit == null) {
                return;
            }
            this.mainDataSource.activeRow.setLookupModelData("mc_unit_no", rowMcUnit.data);
            this.mainDataSource.activeRow.set("mc_unit_no", this.unitNo);
        })
    }

    static showSlideout(modelRow:ModelRow, reply:boolean, unitNo?: string) {
        const layout = Layout.getLayout("lme/dispatch/mobilecomm/MobileCommSendMessage") as MobileCommSendMessage;
        new SlideoutDecorator({
            layout: layout,
            width: window.innerWidth * .75,
            fillVerticalSpace: true,
            title: "Send Message",
            addlComponents: new Button({
                id: "sendBtn",
                caption: "Send Message",
                onClick: () => {layout.sendMessage()},
                backgroundColor: "primary",
                color: "default.reverse",
                borderWidth: 0,
                minWidth: 128,
                rowBreak: false
            }),
            doAfterSlideIn: async () => {
                layout.reply = reply;
                layout.mainDataSource.mode = DataSourceMode.ADD;

                if (reply) {
                    layout.unitNo = modelRow?.get("mc_unit_no");
                    layout.slideOutModelRow = modelRow;
                    layout.searchMessageByUnit(layout.unitNo);
                } else if (unitNo != null) {
                    layout.unitNo = unitNo;
                    const newRow = new ModelRow("lme/dispatch/mobilecomm/mc-message", true, { mc_unit_no: unitNo, delivery_priority: 0 });
                    await newRow.setLookupModelData("mc_unit_no", new ModelRow("lme/dispatch/mobilecomm/mc-unit", false, { id: unitNo }));
                    await layout.mainDataSource.setRowsAndMode(DataSourceMode.ADD, [newRow]);
                    await layout.searchMessageByUnit(unitNo);
                }
            },
        });
    }

    get unitNo(): string {
        return this._unitNo;
    }

    set unitNo(value: string) {
        this._unitNo = value;
    }

    get reply(): boolean {
        return this._reply;
    }

    set reply(value: boolean) {
        this._reply = value;
    }

    get slideOutModelRow(): ModelRow {
        return this._slideOutModelRow;
    }

    set slideOutModelRow(value: ModelRow) {
        this._slideOutModelRow = value;
    }
}
